import * as v from 'valibot';
import { baseImageToSizeMap, IMAGE_SIZES } from './constants';
import { transformedImageSizeMapSchema } from './schema';
import type { EntityPlacementImage, TransformedImageSizeMap } from './types';

export function transformOfferImages(image: EntityPlacementImage): TransformedImageSizeMap {
  const images = IMAGE_SIZES.reduce(
    (acc, size) => ({
      ...acc,
      [size]: {
        url: image[baseImageToSizeMap[size]],
        height: image.height,
        width: image.width,
      },
    }),
    {},
  );

  return v.parse(transformedImageSizeMapSchema, {
    ...images,
    resizable: {
      imagePath: image.resizableImagePath || '',
      height: image.height,
      width: image.width,
    },
  });
}
